// Compatibility shim for react-dom/client in React 16
// This allows libraries expecting React 18 API to work with React 16
import ReactDOM from 'react-dom';

export function createRoot(container) {
  return {
    render(element) {
      ReactDOM.render(element, container);
    },
    unmount() {
      ReactDOM.unmountComponentAtNode(container);
    }
  };
}

export function hydrateRoot(container, element) {
  ReactDOM.hydrate(element, container);
  return {
    render(element) {
      ReactDOM.hydrate(element, container);
    },
    unmount() {
      ReactDOM.unmountComponentAtNode(container);
    }
  };
}
